import { render } from "./VCardForm.vue?vue&type=template&id=1d64b144&scoped=true"
import script from "./VCardForm.vue?vue&type=script&lang=js"
export * from "./VCardForm.vue?vue&type=script&lang=js"

import "./VCardForm.vue?vue&type=style&index=0&id=1d64b144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d64b144"]])

export default __exports__